import _round from 'lodash/round';

/**
 * Number formatter
 * @param {number} value
 * @param {boolean} isFloat
 * @returns string
 */
const format = (value, isFloat = false) => {
    let num = typeof value === "string" ? parseFloat(value) : value;
    if (Number.isNaN(num)) {
        num = 0;
    }
    num = _round(num, 2);
    const [head, tail] = num
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        .split(".");
    if (!tail || !isFloat) {
        return head;
    }
    if (tail.length === 1) {
        return `${head},${tail}0`;
    }
    return `${head},${tail}`;
};

export { format };
//# sourceMappingURL=money.js.map
